import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const SupportIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <svg
        width="45"
        height="45"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.209 14.2166C15.3378 15.4132 13.9265 16.1926 12.3363 16.1926H10.1052C9.33443 16.1926 8.67807 15.7033 8.42953 15.0184C8.12274 14.9269 7.82189 14.8081 7.52832 14.6622C6.90661 14.3533 6.34209 13.9348 5.84515 13.4164C2.62174 14.1245 0.209229 16.9967 0.209229 20.4329V20.882C0.209229 21.4994 0.709755 21.9999 1.32716 21.9999H18.672C19.2894 21.9999 19.7899 21.4994 19.7899 20.882V20.4329C19.7899 17.7784 18.3501 15.4605 16.209 14.2166Z"
          fill={colors.gray}
        />
        <path
          d="M4.65698 11.1122C5.13746 11.1122 5.55566 10.8459 5.77233 10.4529C5.77802 10.4685 5.78381 10.4839 5.78965 10.4994C5.79138 10.504 5.7931 10.5087 5.79482 10.5133C6.3031 11.8512 7.29209 12.9728 8.5962 13.4628C8.9116 12.9617 9.46932 12.6284 10.1052 12.6284H12.3364C12.559 12.6284 12.7661 12.5656 12.9477 12.4641C13.2527 12.2935 13.5269 11.8609 13.6685 11.6316C13.8951 11.2647 14.0707 10.876 14.2264 10.4522C14.3139 10.6111 14.4342 10.7494 14.5784 10.8577V11.4048C14.5784 12.641 13.5727 13.6468 12.3364 13.6468H10.1052C9.6834 13.6468 9.34144 13.9888 9.34144 14.4105C9.34144 14.8324 9.6834 15.1743 10.1052 15.1743H12.3364C14.4149 15.1743 16.1059 13.4833 16.1059 11.4048V10.8577C16.4151 10.6254 16.6151 10.2557 16.6151 9.83928V7.53628V6.65315C16.6151 6.22815 16.4067 5.85211 16.0866 5.6209C15.8384 2.47995 13.2032 0 9.99957 0C6.79587 0 4.16072 2.47995 3.91251 5.62085C3.59247 5.85206 3.38403 6.22815 3.38403 6.65311V9.83919C3.38403 10.5442 3.95678 11.1122 4.65698 11.1122ZM9.99957 1.52757C12.3712 1.52757 14.3273 3.33995 14.5559 5.65244C14.4058 5.77051 14.2829 5.92141 14.1981 6.09457C13.4775 4.21432 11.8687 2.90524 9.99952 2.90524C8.09007 2.90524 6.50708 4.25931 5.80372 6.08706C5.80277 6.08955 5.80186 6.09208 5.8009 6.09462C5.71619 5.92146 5.59323 5.77056 5.44314 5.65248C5.67191 3.33995 7.62798 1.52757 9.99957 1.52757Z"
          fill={colors.gray}
        />
      </svg>
    </SvgIcon>
  );
};

export default SupportIcon;
